import { Select, SelectItem, Spinner } from '@heroui/react';
import { useState } from 'react';
import ReactJson from 'react-json-view';

import { useGetPatientQuery } from '@/patient-app-common/api/patientApi';
import { useLazyGetEducationQuery } from '@/patient-app-common/api/educationApi';
import { useLazyGetApplicationEventsQuery } from '@/patient-app-common/api/applicationEventApi';
import { useLazyGetAllSurveysQuery } from '@/patient-app-common/api/surveyApi';

export function JsonView() {
  const [data, setData] = useState({});
  const [loader, showLoader] = useState(false);

  const { data: patient, isLoading: isLoadingPatient } = useGetPatientQuery();

  const [allSurveys] = useLazyGetAllSurveysQuery();
  const [applicationEvents] = useLazyGetApplicationEventsQuery();
  const [education] = useLazyGetEducationQuery();

  const fetchData = async (callback, id = null) => {
    showLoader(true);
    const results = await callback(id);

    if (results.isSuccess) {
      setData(results.data);
    }

    showLoader(false);
  };

  const handleValueSelect = (e) => {
    switch (e.target.value) {
      case 'education':
        fetchData(education);
        break;

      case 'appevent':
        fetchData(applicationEvents);
        break;

      case 'surveys':
        fetchData(allSurveys);
        break;

      default:
        setData({});
    }
  };

  return (
    <div className="p-8">
      <h1>Application data</h1>
      <div className="flex flex-col py-8">
        <div>
          <Select
            className="max-w-xs"
            label="Data"
            variant="bordered"
            onChange={(e) => handleValueSelect(e)}
          >
            <SelectItem key="appevent" value="appevent">
              Application Events
            </SelectItem>
            <SelectItem key="education" value="education">
              Education
            </SelectItem>
            <SelectItem key="surveys" value="surveys">
              All surveys
            </SelectItem>
          </Select>
          <span className="align-bottom pl-4">
            {(isLoadingPatient || loader) && <Spinner />}
          </span>
        </div>
      </div>
      <div>
        <ReactJson name="patient" collapsed src={patient} />
      </div>
      <div>
        <ReactJson collapsed src={data} />
      </div>
    </div>
  );
}
